// extracted by mini-css-extract-plugin
export default {"autoComplete":"x3-z","error":"y3-z","disabled":"z3-z"};